import findFolderOperation from 'owa-service/lib/operation/findFolderOperation';
import FindFolderRequest from 'owa-service/lib/contract/FindFolderRequest';
import findFolderRequest from 'owa-service/lib/factory/findFolderRequest';
import FindFolderResponseMessage from 'owa-service/lib/contract/FindFolderResponseMessage';
import folderId from 'owa-service/lib/factory/folderId';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { tryConsumeFindFoldersResponse } from 'mini-mail-bootstrap/lib/sessionDataResponseStash';

function configureRequestBody(rootFolderId: string): FindFolderRequest {
    return findFolderRequest({
        FolderShape: folderResponseShape({
            BaseShape: 'IdOnly',
            AdditionalProperties: [
                propertyUri({ FieldURI: 'DistinguishedFolderId' }),
                propertyUri({ FieldURI: 'FolderClass' }),
                propertyUri({ FieldURI: 'FolderDisplayName' }),
                propertyUri({ FieldURI: 'ParentFolderId' }),
                propertyUri({ FieldURI: 'TotalCount' }),
                propertyUri({ FieldURI: 'UnreadCount' }),
            ],
        }),
        Paging: null,
        ParentFolderIds: [folderId({ Id: rootFolderId })],
        ReturnParentFolder: true,
        ShapeName: 'Folder',
        Traversal: 'Deep',
    });
}

export default function findFolders(rootFolderId: string): Promise<FindFolderResponseMessage> {
    const sessionDataFindFoldersResponse = tryConsumeFindFoldersResponse();
    if (sessionDataFindFoldersResponse) {
        // Return the session data response if available instead of going to the server
        return new Promise<FindFolderResponseMessage>(resolve => {
            resolve(sessionDataFindFoldersResponse);
        });
    }

    const requestBody = configureRequestBody(rootFolderId);
    return findFolderOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => response.Body.ResponseMessages.Items[0] as FindFolderResponseMessage);
}
